import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { DOCS_MEGA_COLUMNS, DOCS_OVERVIEW_HREF } from './navMenuConfig';
import { DocsMenuIcon } from './NavMenuIcons';
import { slugifyTrackingValue, trackEvent } from '@/utils/analytics';

type DocsMegaMenuProps = {
  onNavigate: () => void;
};

function trackDocsClick(label: string, href: string, kind: 'item' | 'overview' = 'item') {
  trackEvent({
    name: 'navigation_click',
    buttonId: `navigation_docs_${kind}_${slugifyTrackingValue(href)}`,
    label,
    page: 'global',
    section: 'top_navigation_mega_docs',
    feature: 'navigation',
    eventCategory: 'navigation',
  });
}

export default function DocsMegaMenu({ onNavigate }: DocsMegaMenuProps) {
  return (
    <div className="nav-mega-docs-panel">
      <header className="nav-mega-docs-panel__header">
        <div>
          <p className="nav-mega-section-title">DOCS</p>
          <p className="nav-mega-docs-panel__subtitle">
            Explore the knowledge base behind genotype–phenotype associations
          </p>
        </div>
        <Link
          to={DOCS_OVERVIEW_HREF}
          className="nav-mega-docs-panel__overview"
          onClick={() => {
            trackDocsClick('View all docs', DOCS_OVERVIEW_HREF, 'overview');
            onNavigate();
          }}
        >
          View all docs
          <ArrowRightIcon className="nav-mega-docs-panel__overview-arrow" aria-hidden />
        </Link>
      </header>

      <div className="nav-mega-docs">
        {DOCS_MEGA_COLUMNS.map(column => (
          <div key={column.title} className="nav-mega-docs__column">
            <p className="nav-mega-section-title ml-3">{column.title}</p>
            <ul className="nav-mega-docs__list">
              {column.items.map(item => (
                <li key={item.href}>
                  <Link
                    to={item.href}
                    className="nav-mega-docs-item"
                    onClick={() => {
                      trackDocsClick(item.label, item.href);
                      onNavigate();
                    }}
                  >
                    <span className="nav-mega-docs-item__icon" aria-hidden>
                      <DocsMenuIcon icon={item.icon} />
                    </span>
                    <span className="nav-mega-docs-item__text">
                      <span className="nav-mega-docs-item__title">{item.label}</span>
                      <span className="nav-mega-docs-item__subtitle">{item.subtitle}</span>
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="divider my-4" />
      <div>
        <p className="text-gray-500">
          Explore our <strong>FAQ&lsquo;s</strong> in our{' '}
          <Link to="https://support.disgenet.com/">Help Center</Link>.
        </p>
      </div>
    </div>
  );
}
